module.exports = __webpack_public_path__ + "static/media/instagram.f458da24.svg";